import React from "react";
import { JA } from "utils/strings.ja";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "components/button/styles";

export default function Modal({
  title = "",
  isOpen = false,
  handleCloseModal = () => {},
  primaryButton = "",
  cancelText = "",
  primaryAction = () => {},
  children,
  error,
  isShowActions = true,
  style = {},
  // Tailwind max-width class of the dialog
  widthClass = "max-w-2xl",
  primaryDisabled = false,
  // shows a spinner in the primary button and disables it
  primaryLoading = false,
}) {
  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      const element = document.querySelector(".dialog-layout");
      if (element) {
        const parent = element.parentElement;
        if (parent) parent.classList.add("overflow-auto");
      }
    }, 0);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    isOpen && (
      <div
        id="static-modal"
        data-modal-backdrop="static"
        tabIndex="-1"
        // aria-hidden="true"
        className={`${
          isOpen ? "" : "hidden"
        } w-full h-full flex justify-center items-center bg-black_3-900.71 fixed top-0 right-0 left-0 z-999`}
      >
        <div className={`relative w-full ${widthClass} max-h-full p-4 dialog-layout`}>
          <div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
            {/* Modal header */}
            <div className="flex items-center justify-between p-4 border-b border-slate-300 rounded-t md:p-5 dark:border-gray-600">
              <h3 className="text-xl font-semibold text-black dark:text-white" style={style?.title}>
                {title}
              </h3>
              <button
                type="button"
                className="inline-flex items-center justify-center w-8 h-8 text-sm text-slate-400 bg-transparent rounded-lg hover:bg-slate-200 hover:text-black ms-auto dark:hover:bg-gray-600 dark:hover:text-white"
                data-modal-hide="static-modal"
                onClick={handleCloseModal}
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            {/* end Modal header */}
            {/* Modal body */}
            <div className="p-4 space-y-4 md:p-5 max-h-132.5 overflow-auto">{children}</div>
            {/* end Modal body */}
            <div className="px-5 mb-4 text-red-700">{error}</div>
            {/* Modal footer */}
            { isShowActions && (<div className="bg-slate-50 px-4 py-2 sm:flex sm:flex-row sm:px-6 border-t border-slate-300 justify-end">
              <button
                data-modal-hide="static-modal"
                type="button"
                className={`ms-3 ${SECONDARY_BUTTON}`}
                onClick={handleCloseModal}
              >
                {cancelText || JA.common.cancel}
              </button>
              <button
                data-modal-hide="static-modal"
                type="submit"
                className={`ml-2 ${PRIMARY_BUTTON}`}
                onClick={primaryAction}
                disabled={primaryDisabled || primaryLoading}
              >
                {primaryLoading && (
                  <span
                    className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"
                    aria-hidden="true"
                  />
                )}
                {primaryButton}
              </button>
            </div>) }
            {/* end Modal footer */}
          </div>
        </div>
      </div>
    )
  );
}
